import Format from "../components/format/Format";

export default function Jwt() {

    return (
        <Format inputLabel='JWT' 
            buttons={[
                {
                    api: '/api/jwt/decode',
                    buttonLabel: 'Decode',
                    outputLabel: 'Decoded',
                },
            ]}
        />
    );
}